import { render, staticRenderFns } from "./MenuItemToggle.vue?vue&type=template&id=69a6b97c&scoped=true"
import script from "./MenuItemToggle.vue?vue&type=script&lang=js"
export * from "./MenuItemToggle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69a6b97c",
  null
  
)

export default component.exports